<template>
  <div
    class="t-th"
    :style="{
			'min-width': width + 'px',
			'border-left-width': borderType === 'grid' ? '1px' : '0',
			'border-color' : borderColor,
			'justify-content': thAlignCpd
		}"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    align: {
      type: String,
      default: "center"
    },
    width: {
      type: String,
      default: undefined
    }
  },
  data() {
    return {
      borderColor: '#e4e4e4',
			borderType: 'grid',
      tdAlign: "center"
    };
  },
  inject: ["table", "tr"],

  created() {
    this.borderColor = this.table.borderColor;
		this.borderType = this.table.borderType;
    if (this.tr.align) {
      this.thAlign = this.tr.align;
    } else {
      this.thAlign = this.align;
    }
  },

  computed: {
    thAlignCpd() {
      let nameAlign = "";
      switch (this.thAlign) {
        case "left":
          nameAlign = "flex-start";
          break;
        case "center":
          nameAlign = "center";
          break;
        case "right":
          nameAlign = "flex-end";
          break;
        default:
          nameAlign = "center";
          break;
      }
      return nameAlign;
    }
  }
};
</script>

<style>
.t-th {
  flex: 1;
  display: flex;
  align-items: center;
  font-size: 14px;
  text-align: center;
  color: #333333;
  border-top: 1px #e4e4e4 solid;
	border-left: 1px #e4e4e4 solid;
  padding: 15px 10px;
  background: #ffffff;
}
</style>